module.exports = __webpack_public_path__ + "static/img/moby.957bae6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/moby.jpg
// module id = oCDD
// module chunks = 1